import React, {useState, useEffect, useMemo} from 'react';
import useApiControl from './common/useApiControl';
import { recoverFromFatalError } from './common/roomFatalError';
import { useLocation } from 'react-router-dom';
import BaseHeader from './components/headers/BaseHeader';
import RoomHeader from './components/headers/RoomHeader';
import MyUser from './components/mypage/MyUser';
import OtherUser from './components/mypage/OtherUser';


function Mypage() 
{
    const [myUser, setMyUser] = useState(null);
    const [otherUser, setOtherUser] = useState(null);
    const [nextComponent, setNextComponent] = useState(null);
    const [makeEvents, setMakeEvents] = useState(null);
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const user_id = query.get('id');


    
    //自分のマイページ向けデータの取得
    const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
      action: '/get_user',
      method: 'POST',
    });
  
    const updateMyUser = () => {
        executeRequest1().catch((error) => {
            console.error(error);
            recoverFromFatalError({
                loggedInMessage: 'エラーが発生しました。トップページに戻ります。',
                loggedOutMessage: 'エラーが発生しました。ログインの有効期限が切れた可能性があります。もう一度ログインしてください。',
                redirectTo: './',
                loggedOutRedirectTo: './login',
            });
        });
    };
    
    useEffect(() => {
        updateMyUser();
    }, []);
  
    useEffect(() => {
        if (data1) {
          setMyUser(data1);
        }
    }, [data1]);

    useEffect(() => {
      if (myUser && user_id === null) {
        // getパラメータにid指定がない場合myUserで確定
        setNextComponent('myUser');
      } else if(myUser && otherUser) {
        // 2人分のユーザーデータ取得が完了したら
        setNextComponent('otherUser');
      }
    }, [myUser]);


    // 他人のマイページ向けデータの取得
    const params2 = useMemo(() => {
      return user_id !== null ? { user_id } : {};
    }, [user_id]);
    
    const { data: data2, loading: loading2, executeRequest: executeRequest2 } = useApiControl({
      action: '/get_user',
      params: params2,
      method: 'POST',
    });
  
    const updateOtherUser = () => {
        executeRequest2().catch((error) => {
            console.error(error);
            window.location.href = './';
        });
    };
  
    useEffect(() => {
      if (params2.user_id) {
        updateOtherUser();
      }
    }, [params2]);
  
    useEffect(() => {
        if (data2) {
          setOtherUser(data2);
        }
    }, [data2]);

    useEffect(() => {
      if(myUser && otherUser) {
        // 2人分のユーザーデータ取得が完了したら
        setNextComponent('otherUser');
      }
    }, [otherUser]);

  // user owners events
  //todo
  // ここまでやった
  // このAPIはたたく
  // 実行条件とパラメータセットをどうすっぺ


  const params3 = useMemo(function() {
    if (nextComponent == 'myUser') {
      return {
        userId: myUser.id,
        includesDeleted: true
      }
    } else if (nextComponent == 'otherUser') {
      return {
        userId: otherUser.id,
        includesDeleted: true
      }
    }
  }, [nextComponent]);
  const { data: data3, loading: loading3, executeRequest: executeRequest3 } = useApiControl({
    action: '/get_owners_event',
    params: params3,
    method: 'POST',
  });

  useEffect(() => {
    if (params3) {
      executeRequest3().catch((error) => {
        console.error(error);
      });
    }
  }, [params3]);

  useEffect(() => {
    if (data3?.events && data3.events.length) {
      setMakeEvents(data3.events);
    }
  }, [data3]);

    // 表示コンポーネント未決の間はメインコンテンツ何も表示しない
    if (nextComponent == null) {
      return (
        <BaseHeader/>
      )
    // 自分のマイページ
    } else if (nextComponent == 'myUser') {
      return (
        <>
          <RoomHeader user={myUser} />
          <MyUser user={myUser} makeEvents={makeEvents}/>
        </>
      )
    // 他人のマイページ
    } else if (nextComponent == 'otherUser') {
      return (
        <>
          <RoomHeader user={myUser} />
          <OtherUser user={otherUser} makeEvents={makeEvents} />
        </>
      )
    }
}

export default Mypage;
